import React, { useRef, useEffect } from 'lib/react';
import { useLocation } from 'lib/router';
import { useSelector } from 'lib/redux';
import { EVButton, EVTypography, makeStyles } from 'lib/components';
import { useTranslation } from 'lib/translation';
import { MAIN_CONTENT_ID } from 'constants/AppConstants';

const useStyles = makeStyles((theme) => ({
  skipNavHidden: {
    position: 'absolute',
    top: '-100px',
  },
  skipNav: {
    position: 'absolute',
    top: '-100px',
    borderRadius: '8px',
    padding: '10px',
    border: `2px solid ${theme.evPalette.ocean[700]}`,
    background: theme.evPalette.salt[100],
    boxShadow: '0px 4px 4px 0px rgba(0, 0, 0, 0.25)',
    transition: 'top 0.3s ease',
    zIndex: 1000,
    '&:focus': {
      top: '0',
      display: 'inline',
    },
    '&:hover': {
      background: theme.evPalette.salt[100],
      display: 'inline',
    },
  },
  skipNavText: {
    color: theme.evPalette.ocean[800],
    fontFamily: '"Noto Sans", sans-serif',
    fontSize: '14px',
    fontWeight: 700,
    lineHeight: '150%',
  },
}));

function SkipNavigation() {
  const skipLinkRef = useRef(null);
  const location = useLocation();
  const styles = useStyles();
  const { t } = useTranslation();
  const { myevRefreshSkipNav } = useSelector(({ featureFlag }) => ({ myevRefreshSkipNav: featureFlag.myevRefreshSkipNav }));

  if (!myevRefreshSkipNav) {
    return null;
  }

  useEffect(() => {
    setTimeout(() => {
      if (skipLinkRef.current) {
        skipLinkRef.current.focus();
      }
    }, 500);
  }, [location.pathname]);

  return (
    <>
      <EVButton className={styles.skipNavHidden} ref={skipLinkRef} />
      <EVButton href={`#${MAIN_CONTENT_ID}`} variant="outlined" className={styles.skipNav}>
        <EVTypography variant="body1" className={styles.skipNavText}>{t('skip_navigation__text')}</EVTypography>
      </EVButton>
    </>
  );
}

export default SkipNavigation;
